import React, { useMemo } from "react";
import moment from "moment";
import { ContentHomeAgent } from "./HomeUserInside.styled";
import { ROLES } from "../../util/RolesConstants";
import HomeSurvey from "../../containers/HomeSurveyContainer/HomeSurvey";
import MoodMeterHomeContainer from "../../containers/MoodMeterHomeContainer/MoodMeterHomeContainer";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import HomeGamification from "../../containers/GamificationContainer/HomeGamification";
import HomeEngagement from "../../containers/EngagementContainer/HomeEngagement";
import HomWellness from "../../containers/WellnessContainer/HomeWellnessContainer";
import CalendarEvent from "../CalendarEvent/CalendarEvent";
import CoachesHome from "../CoachesHome/CoachesHome";
import HomeAdminInside from "../HomeAdminInside/HomeAdminInside";
moment.locale("en");

const HomeUserInside = () => {
  const user = useMemo(() => getStateLoginComplete(), []);
  const date = moment().format("dddd, MMM D, YYYY");

  return (
    <>
      {ROLES.AGENT === user.roleId ? (
        <ContentHomeAgent>
          <h2 className="home-title">
            Hello {user.displayName.split(" ")[0]},
            <span className="home-title_date">Today is {date}</span>
          </h2>
          <div className="home-meterwellness">
            <MoodMeterHomeContainer />
            <HomWellness />
          </div>
          <div className="home-calmedarcoaches">
            <CalendarEvent isAgent={ROLES.AGENT === user.roleId} />
            <HomeSurvey />
            <CoachesHome />
          </div>
          <HomeGamification />
          <HomeEngagement />
        </ContentHomeAgent>
      ) : (
        <HomeAdminInside />
      )}
    </>
  );
};

export default HomeUserInside;
